// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const runInClientMax = 120;

export const runInCountryOneMax = 6;

export const runInCrmReferenceOneMax = 120;

export const runInFileIdsMax = 10;

export const runInProblemMax = 8000;

export const RunIn = zod.object({
  "client": zod.string().min(1).max(runInClientMax),
  "country": zod.union([zod.string().max(runInCountryOneMax),zod.null()]).optional(),
  "crm_reference": zod.union([zod.string().max(runInCrmReferenceOneMax),zod.null()]).optional(),
  "file_ids": zod.array(zod.uuid()).max(runInFileIdsMax).optional(),
  "idea_id": zod.union([zod.uuid(),zod.null()]).optional(),
  "industry_id": zod.union([zod.uuid(),zod.null()]).optional(),
  "problem": zod.string().min(1).max(runInProblemMax)
});

export type RunIn = zod.input<typeof RunIn>;
export type RunInOutput = zod.output<typeof RunIn>;
